"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class GetReviewsResponseReview extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: '895c9155-804f-47be-aa48-c387752db9b7',
        description: 'Unique klatenvertellen ID of review',
    }),
    tslib_1.__metadata("design:type", String)
], GetReviewsResponseReview.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: 'John Doe', description: 'Author of the review' }),
    tslib_1.__metadata("design:type", String)
], GetReviewsResponseReview.prototype, "author", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(10),
    (0, base_models_1.Docs)({ example: 10, description: 'Rating that the author gave for this review' }),
    tslib_1.__metadata("design:type", Number)
], GetReviewsResponseReview.prototype, "rating", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: 'Ik ben heel erg tevreden!',
        description: 'Title of the review. This maps to the DEFAULT_ONELINER field of Klantenvertellen',
    }),
    tslib_1.__metadata("design:type", String)
], GetReviewsResponseReview.prototype, "title", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: 'Essent is een top bedrijf en ze helpen je altijd erg goed',
        description: 'Content of the review. This maps to the DEFAULT_OPINION field of Klantenvertellen',
    }),
    tslib_1.__metadata("design:type", String)
], GetReviewsResponseReview.prototype, "content", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: 'Den Bosch',
        description: 'City where the author of the review lives',
    }),
    tslib_1.__metadata("design:type", String)
], GetReviewsResponseReview.prototype, "city", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: '2022-11-02T23:00:05.575Z',
        description: 'Date when the review was placed',
    }),
    tslib_1.__metadata("design:type", String)
], GetReviewsResponseReview.prototype, "date", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: true,
        description: 'Content of the review. This maps to the DEFAULT_RECOMMEND field of klantenvertellen.',
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetReviewsResponseReview.prototype, "wouldRecommend", void 0);
exports.default = GetReviewsResponseReview;
